export default {
  root: {
    borderRadius: '12px'
  }
};
